import React from "react";
import Banner from "./Banner";
import dynamic from "next/dynamic";
const Services = dynamic(() => import("./Services"),{ssr: true});
const TechStack = dynamic(() => import("./TechStack"),{ssr: true});
const Enterprises = dynamic(() => import("./Enterprises"),{ssr: true});
const UseCases = dynamic(() => import("./UseCases"),{ssr: true});
const Faq = dynamic(() => import("../Home/Faq"),{ssr: true});
const BuildSection = dynamic(() => import("@/Components/BuildSection"),{ssr: true});
// import { ActionCardBlock } from "../Services";
const RFPForm = dynamic(() => import("../Home/Quote"),{ssr: true});
const HocHead = dynamic(() => import("@/Components/HigherOrderComponent/HocHead"),{ssr: true});
interface ServiceInnerProps {
  slug?: any;
  data?: any;
  seo?: any;
  isMobile?: boolean;
  breadcrumbs?: any;
}

const ServicesInnerPage: React.FC<ServiceInnerProps> = ({
  data,
  isMobile,
  seo,
  breadcrumbs,
}) => {
  const blocks = data;

  return (
    <>
      {seo && <HocHead seo={seo} />}

      {blocks?.map((block: any, i: number) => {
        switch (block?.__component) {
          case "blocks.2025-banner-inner":
            return (
              <Banner
                key={i}
                data={block}
                isMobile={isMobile}
                breadcrumbs={breadcrumbs}
              />
            );
          case "blocks.2025-ai-services":
            return <Services key={i} data={block} isMobile={isMobile} />;
          case "blocks.ai-cards":
            return <Enterprises key={i} data={block} isMobile={isMobile} />;
          case "blocks.2025-technology":
            return <TechStack key={i} data={block} />;
          case "blocks.2025-use-case-card":
            return <UseCases key={i} data={block} isMobile={isMobile} />;
          case "blocks.2025-home-fa-qs":
            return <Faq key={i} data={block} />;
          case "shared.2025-action-card":
            return <BuildSection key={i} data={block} />;
          case "blocks.2025-home-rfp":
            return <RFPForm key={i} data={block} />;
          default:
            return (
              <div
                key={i}
                className="text-red-500 p-4 bg-red-50 border border-red-200 rounded-md mt-4 max-w-[1500px] mx-auto"
              >
                Unknown block type: {block?.__component || "undefined"}
              </div>
            );
        }
      })}
    </>
  );
};

export default ServicesInnerPage;
